exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n  padding: 25px;\n}\n\n.card {\n  padding-top: 40px;\n  /*display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: space-around;*/\n}\n\n.card:hover{\n  background-color: #e8ebef;\n}\n\n.img-resize {\n  min-height:400px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/explore/explore.component.css
// module id = ../../../../../src/app/explore/explore.component.css
// module chunks = main